<template>
  <div class="pageWrap">
    <!-- 导航栏 -->
    <navi-header :isScroll="isScroll"></navi-header>

    <!-- banner模块 -->
    <div class="bannerWrap">
      <div v-if="$store.state.screenWidth <= 768" class="banner_img_bg_box">
        <!-- <img
          class="banner_img_bg"
          src="../assets/images/ABUIABACGAAgiq71kQYotoCHmQcwuAY40AM.jpg"
          alt=""
        /> -->
        <img
          class="banner_img_bg"
          src="../assets/images/loadImg.jpg"
          alt=""
        />
      </div>

      <div class="videBox" v-else>
        <video
          id="jz_banner_flv"
          playsinline
          muted="muted"
          loop="loop"
          autoplay="autoplay"
          class="banner_flv_bg"
          src="../assets/images/bgVideoMy.mp4"
          v-on:canplay="videoPlayFun"
          v-on:playing="videoPlayingFun"
        ></video>
        <img v-if="videoLoad" class="videoLoadImg" src="../assets/images/loadImg.jpg" alt="">
      </div>
      

      <div
        class="bannerContentImgBox centerBox wow animate__animated animate__fadeIn"
        @click="goMyworksFun"
      >
        <!-- <img
          class="bannerContentImg"
          src="../assets/images/ABUIABAEGAAgjZPjkQYovcLsugcwwBY4jgk.png"
          alt=""
        /> -->
        <img
          class="bannerContentImg"
          src="../assets/images/bannerTitle.png"
          alt=""
        />
      </div>
    </div>

    <!-- 核心业务 -->
    <div class="blockBox">
      <div class="blockTitle wow animate__animated animate__zoomIn">
        核心业务
      </div>
      <img
        class="blockImg wow animate__animated animate__bounceInUp"
        src="../assets/images/k3.png"
        alt=""
      />
      <img
        class="teamTitle wow animate__animated animate__zoomIn"
        src="../assets/images/ABUIABAEGAAggqXjkQYolKX9MTDaDzho.png"
        alt=""
      />

      <!-- 团队 -->
      <div class="blockWrap teamWrap wow animate__animated animate__flash">
        <div class="blockItem">
          <img
            class="blockItemImg"
            src="../assets/images/myteam1.png"
            alt=""
          />
        </div>
        <div class="blockItem">
          <img
            class="blockItemImg"
            src="../assets/images/myteam2.png"
            alt=""
          />
        </div>
        <div class="blockItem">
          <img
            class="blockItemImg"
            src="../assets/images/myteam3.png"
            alt=""
          />
        </div>
        <div class="blockItem">
          <img
            class="blockItemImg"
            src="../assets/images/myteam4.png"
            alt=""
          />
        </div>
        <div class="blockItem">
          <img
            class="blockItemImg"
            src="../assets/images/myteam5.png"
            alt=""
          />
        </div>
      </div>

      <div class="dearTitle">
        <img
          class="dearTitleImg wow animate__animated animate__zoomIn"
          src="../assets/images/ABUIABAEGAAggMLjkQYoj9PxqQIwuA04XA.png"
          alt=""
        />
        <img
          class="dearTitleSubImg"
          src="../assets/images/ABUIABAEGAAg28LjkQYomcLzPTCYBDhY.png"
          alt=""
        />
      </div>

      <div class="dearWrap blockWrap">
        <div class="dearItem">
          <img
            class="dearItemImg"
            src="../assets/images/dear1.jpg"
            alt=""
          />
        </div>
        <div class="dearItem">
          <img
            class="dearItemImg"
            src="../assets/images/dear2.jpg"
            alt=""
          />
        </div>
        <div class="dearItem">
          <img
            class="dearItemImg"
            src="../assets/images/dear3.jpg"
            alt=""
          />
        </div>
      </div>
    </div>

    <!-- 案例 -->
    <div class="blockBox acseBox">
      <div class="blockTitle wow animate__animated animate__zoomIn">
        我们的案例与观点
      </div>
      <div class="caseWrap">
        <!-- 左侧 -->
        <div class="caseBlock" v-if="caseListObj.left.length > 0">
          <div
            class="caseItem wow animate__animated animate__fadeIn"
            v-for="item in caseListObj.left"
            :key="item.id"
          >
            <a :href="item.url" target="_blank">
              <img class="caseItemImg" :src="item.picture" alt="" />
              <div class="caseItemTitle">
                <span>{{ item.title }}</span>
              </div>
              <p class="caseItemSubTitle">{{ item.subTitle }}</p>
            </a>
          </div>
        </div>
        <!-- 中间 -->
        <div class="caseBlock" v-if="caseListObj.center.length > 0">
          <div
            class="caseItem wow animate__animated animate__fadeIn"
            v-for="item in caseListObj.center"
            :key="item.id"
          >
            <a :href="item.url" target="_blank">
              <img class="caseItemImg" :src="item.picture" alt="" />
              <div class="caseItemTitle">
                <span>{{ item.title }}</span>
              </div>
              <p class="caseItemSubTitle">{{ item.subTitle }}</p>
            </a>
          </div>
        </div>
        <!-- 右侧 -->
        <div class="caseBlock" v-if="caseListObj.right.length > 0">
          <div
            class="caseItem wow animate__animated animate__fadeIn"
            v-for="item in caseListObj.right"
            :key="item.id"
          >
            <a :href="item.url" target="_blank">
              <img class="caseItemImg" :src="item.picture" alt="" />
              <div class="caseItemTitle">
                <span>{{ item.title }}</span>
              </div>
              <p class="caseItemSubTitle">{{ item.subTitle }}</p>
            </a>
          </div>
        </div>
        <!-- <div class="caseBlock">
          <div class="caseItem wow animate__animated animate__fadeIn" v-for="item in caseListObj.rightList" :key="item.id">
            <a
              :href="item.linkUrl"
              target="_blank"
            >
              <img
                class="caseItemImg"
                :src="require('@/assets/imgs/' + item.img)"
                alt=""
              />
              <div class="caseItemTitle">
                <span>{{ item.title }}</span>
              </div>
              <p class="caseItemSubTitle">{{ item.subTitle }}</p>
            </a>
          </div>
        </div> -->
      </div>
    </div>

    <!-- 时间轴 -->
    <div class="blockBox timeBox">
      <img
        class="timeTitleImg wow animate__animated animate__zoomIn"
        src="../assets/images/ABUIABAEGAAgweDjkQYo78ncogIw-As4Zg.png"
        alt=""
      />
      <!-- <img
        class="timeBlockImg wow animate__animated animate__fadeInLeft"
        src="../assets/images/ABUIABAEGAAgwuDjkQYo_q7-iQMwxBQ4ngk.png"
        alt=""
      /> -->
      <img
        class="newtimeBlockImg wow animate__animated animate__fadeInLeft"
        src="../assets/images/gai8.png"
        alt=""
      />
    </div>

    <!-- 客户 -->
    <div class="blockBox timeBox customBox">
      <div class="blockTitle wow animate__animated animate__zoomIn">
        我们的客户
      </div>
      <!-- <div class="customWrap">
        
        
        <div class="customItem">
          <img class="customItemImg" src="../assets/images/logo/i_shipin.png" alt="" />
        </div>
        <div class="customItem">
          <img
            class="customItemImg"
            src="../assets/images/ABUIABACGAAg1b7xkQYopI3n_gYwwAI48AE.jpg"
            alt=""
          />
        </div>
        <div class="customItem">
          <img
            class="customItemImg"
            src="../assets/images/ABUIABACGAAgor7xkQYovsOHpQIwwAI48AE.jpg"
            alt=""
          />
        </div>
        <div class="customItem">
          <img
            class="customItemImg"
            src="../assets/images/ABUIABACGAAgsr7xkQYoqLmuzwQwwAI48AE.jpg"
            alt=""
          />
        </div>





        <div class="customItem">
          <img
            class="customItemImg"
            src="../assets/images/ABUIABACGAAgsL7xkQYoyIiyqwcwwAI48AE.jpg"
            alt=""
          />
        </div>



        <div class="customItem">
          <img class="customItemImg" src="../assets/images/ALIPAY.jpg" alt="" />
        </div>
        <div class="customItem">
          <img
            class="customItemImg"
            src="../assets/images/bilibili.jpg"
            alt=""
          />
        </div>
        <div class="customItem">
          <img
            class="customItemImg"
            src="../assets/images/Budweiser.jpg"
            alt=""
          />
        </div>
        <div class="customItem">
          <img
            class="customItemImg"
            src="../assets/images/ByteDance.jpg"
            alt=""
          />
        </div>
        <div class="customItem">
          <img
            class="customItemImg"
            src="../assets/images/ABUIABACGAAgnr7xkQYo_Pis-wEwwAI48AE.jpg"
            alt=""
          />
        </div>
        <div class="customItem">
          <img
            class="customItemImg"
            src="../assets/images/ABUIABACGAAgoL7xkQYoscvnqwYwwAI48AE.jpg"
            alt=""
          />
        </div>
        
        <div class="customItem">
          <img
            class="customItemImg"
            src="../assets/images/ABUIABACGAAgpL7xkQYowrPq8wEwwAI48AE.jpg"
            alt=""
          />
        </div>
        <div class="customItem">
          <img
            class="customItemImg"
            src="../assets/images/ABUIABACGAAgp77xkQYo0IWe7AIwwAI48AE.jpg"
            alt=""
          />
        </div>
        <div class="customItem">
          <img
            class="customItemImg"
            src="../assets/images/ABUIABAEGAAgpraSkgYotszSjwQwwAI48AE.png"
            alt=""
          />
        </div>
        <div class="customItem">
          <img
            class="customItemImg"
            src="../assets/images/ABUIABACGAAgq77xkQYokPrisgQwwAI48AE.jpg"
            alt=""
          />
        </div>
        <div class="customItem">
          <img
            class="customItemImg"
            src="../assets/images/ABUIABACGAAgrb7xkQYoxPPo9gMwwAI48AE.jpg"
            alt=""
          />
        </div>

        <div class="customItem">
          <img
            class="customItemImg"
            src="../assets/images/ABUIABAEGAAgpraSkgYogtWNRjDAAjjwAQ.png"
            alt=""
          />
        </div>
        <div class="customItem">
          <img
            class="customItemImg"
            src="../assets/images/ABUIABACGAAgrr7xkQYo4MOA8wEwwAI48AE.jpg"
            alt=""
          />
        </div>
        
        
        <div class="customItem">
          <img
            class="customItemImg"
            src="../assets/images/ABUIABACGAAgtL7xkQYosJnZtwYwwAI48AE.jpg"
            alt=""
          />
        </div>
        <div class="customItem">
          <img
            class="customItemImg"
            src="../assets/images/ABUIABACGAAgtb7xkQYogNGFkgIwwAI48AE.jpg"
            alt=""
          />
        </div>

        <div class="customItem">
          <img
            class="customItemImg"
            src="../assets/images/ABUIABACGAAgwL7xkQYowNqH5wYwwAI48AE.jpg"
            alt=""
          />
        </div>
        <div class="customItem">
          <img
            class="customItemImg"
            src="../assets/images/ABUIABACGAAgwr7xkQYokMTwpAUwwAI48AE.jpg"
            alt=""
          />
        </div>
        <div class="customItem">
          <img
            class="customItemImg"
            src="../assets/images/ABUIABACGAAgxL7xkQYo8t2QFDDAAjjwAQ.jpg"
            alt=""
          />
        </div>
        <div class="customItem">
          <img
            class="customItemImg"
            src="../assets/images/ABUIABACGAAgxr7xkQYosKfLzwMwwAI48AE.jpg"
            alt=""
          />
        </div>
        <div class="customItem">
          <img
            class="customItemImg"
            src="../assets/images/ABUIABACGAAgyL7xkQYoiM_cnwQwwAI48AE.jpg"
            alt=""
          />
        </div>
        <div class="customItem">
          <img
            class="customItemImg"
            src="../assets/images/ABUIABACGAAgy77xkQYo-o_oogIwwAI48AE.jpg"
            alt=""
          />
        </div>

        <div class="customItem">
          <img
            class="customItemImg"
            src="../assets/images/ABUIABACGAAgzb7xkQYo6LHYjQYwwAI48AE.jpg"
            alt=""
          />
        </div>
        <div class="customItem">
          <img
            class="customItemImg"
            src="../assets/images/ABUIABACGAAgz77xkQYogLXfsQIwwAI48AE.jpg"
            alt=""
          />
        </div>
        <div class="customItem">
          <img
            class="customItemImg"
            src="../assets/images/ABUIABACGAAg0b7xkQYo1Nv3rAcwwAI48AE.jpg"
            alt=""
          />
        </div>
        <div class="customItem">
          <img
            class="customItemImg"
            src="../assets/images/ABUIABACGAAg077xkQYozJru_QUwwAI48AE.jpg"
            alt=""
          />
        </div>
        
        <div class="customItem">
          <img
            class="customItemImg"
            src="../assets/images/ABUIABACGAAg177xkQYopeTGBDDAAjjwAQ.jpg"
            alt=""
          />
        </div>
      </div> -->

      <div class="customWrap">
        <!-- 食品 -->
        <div class="customItem">
          <img
            style="margin-top: 6%;"
            class="customItemImg"
            src="../assets/images/logo/i_shipin.png"
            alt=""
          />
        </div>
        <div class="customItem">
          <img
            class="customItemImg"
            src="../assets/images/ABUIABACGAAg1b7xkQYopI3n_gYwwAI48AE.jpg"
            alt=""
          />
        </div>
        <div class="customItem">
          <img
            class="customItemImg"
            src="../assets/images/ABUIABACGAAgor7xkQYovsOHpQIwwAI48AE.jpg"
            alt=""
          />
        </div>
        <div class="customItem">
          <img
            class="customItemImg"
            src="../assets/images/ABUIABACGAAgsr7xkQYoqLmuzwQwwAI48AE.jpg"
            alt=""
          />
        </div>
        <div class="customItem">
          <img
            class="customItemImg"
            src="../assets/images/ABUIABACGAAgsL7xkQYoyIiyqwcwwAI48AE.jpg"
            alt=""
          />
        </div>
        <div class="customItem">
          <img
            style="height: 120%; max-height: 120%"
            class="customItemImgSecond"
            src="../assets/images/logo/fg-02_07.gif"
            alt=""
          />
        </div>
        <div class="customItem">
          <img
            style="height: 120%; max-height: 120%"
            class="customItemImgSecond"
            src="../assets/images/logo/fg-02_08.gif"
            alt=""
          />
        </div>
        <div class="customItem">
          <img
            style="height: 120%; max-height: 120%"
            class="customItemImgSecond"
            src="../assets/images/logo/fg-02_09.gif"
            alt=""
          />
        </div>

        <!-- 美妆日化 -->
        <div class="customItem">
          <img
            class="customItemImg"
            src="../assets/images/logo/i_meizhuang.png"
            alt=""
          />
        </div>
        <div class="customItem">
          <img
            class="customItemImgSecond"
            src="../assets/images/logo/fg-02_11.gif"
            alt=""
          />
        </div>
        <div class="customItem">
          <img
            class="customItemImg"
            src="../assets/images/ABUIABACGAAgu77xkQYouaDFtwUwwAI48AE.jpg"
            alt=""
          />
        </div>
        <div class="customItem">
          <img
            class="customItemImg"
            src="../assets/images/ABUIABACGAAgp77xkQYo0IWe7AIwwAI48AE.jpg"
            alt=""
          />
        </div>
        <div class="customItem">
          <img
            class="customItemImg"
            src="../assets/images/ABUIABACGAAgt77xkQYoybORtQIwwAI48AE.jpg"
            alt=""
          />
        </div>
        <div class="customItem">
          <img
            style="margin-top: 10%"
            class="customItemImgSecond"
            src="../assets/images/logo/fg-02_19.gif"
            alt=""
          />
        </div>
        <div class="customItem">
          <img
            style="margin-top: 10%"
            class="customItemImgSecond"
            src="../assets/images/logo/fg-02_21.gif"
            alt=""
          />
        </div>
        <div class="customItem">
          <img
            style="width: 80%; margin-right: 7%; margin-bottom: 7%"
            class="customItemImg"
            src="../assets/images/logo/logo_am.png"
            alt=""
          />
        </div>
        <!-- amrio  -->

        <!-- 家电消费 -->
        <div class="customItem">
          <img
          style="margin-top: 6%;"
            class="customItemImg"
            src="../assets/images/logo/i_jiadian.png"
            alt=""
          />
        </div>
        <div class="customItem">
          <img
            class="customItemImg"
            src="../assets/images/ABUIABACGAAgtL7xkQYosJnZtwYwwAI48AE.jpg"
            alt=""
          />
        </div>
        <div class="customItem">
          <img
            class="customItemImg"
            src="../assets/images/ABUIABACGAAgq77xkQYokPrisgQwwAI48AE.jpg"
            alt=""
          />
        </div>
        <div class="customItem">
          <img
            class="customItemImg"
            src="../assets/images/ABUIABACGAAgzb7xkQYo6LHYjQYwwAI48AE.jpg"
            alt=""
          />
        </div>
        <div class="customItem">
          <img
            class="customItemImgSecond"
            src="../assets/images/logo/fg-02_25.gif"
            alt=""
          />
        </div>
        <div class="customItem">
          <img
            class="customItemImgSecond"
            src="../assets/images/logo/fg-02_33.gif"
            alt=""
          />
        </div>
        <div class="customItem">
          <img
            style="width: 60%"
            class="customItemImgSecond"
            src="../assets/images/logo/logo_br.jpg"
            alt=""
          />
        </div>
        <!-- breo -->
        <div class="customItem">
          <img
            class="customItemImg"
            src="../assets/images/logo/fg-02_35.gif"
            alt=""
          />
        </div>

        <!-- 互联网服务 -->
        <div class="customItem">
          <img
            style="margin-bottom: 8%;"
            class="customItemImg"
            src="../assets/images/logo/i_hulian.png"
            alt=""
          />
        </div>
        <div class="customItem">
          <img class="customItemImg" src="../assets/images/ALIPAY.jpg" alt="" />
        </div>
        <div class="customItem">
          <img
            class="customItemImg"
            src="../assets/images/bilibili.jpg"
            alt=""
          />
        </div>
        <div class="customItem">
          <img
            class="customItemImg"
            src="../assets/images/ABUIABACGAAgvr7xkQYopv3lkQUwwAI48AE.jpg"
            alt=""
          />
        </div>
        <div class="customItem">
          <img
            class="customItemImg"
            src="../assets/images/ByteDance.jpg"
            alt=""
          />
        </div>
        <div class="customItem">
          <img
            class="customItemImg"
            src="../assets/images/ABUIABACGAAgyL7xkQYoiM_cnwQwwAI48AE.jpg"
            alt=""
          />
        </div>
        <!-- 汽车金融 -->
        <div class="customItem">
          <img
            class="customItemImg"
            src="../assets/images/logo/i_qiche.png"
            alt=""
          />
        </div>
        <div class="customItem">
          <img
            class="customItemImgSecond"
            src="../assets/images/logo/fg-02_44.gif"
            alt=""
          />
        </div>
        <div class="customItem">
          <img
            class="customItemImg"
            src="../assets/images/ABUIABACGAAgrr7xkQYo4MOA8wEwwAI48AE.jpg"
            alt=""
          />
        </div>
        <div class="customItem">
          <img
            style="margin-right: 10%"
            class="customItemImgSecond"
            src="../assets/images/logo/fg-02_46.gif"
            alt=""
          />
        </div>
        <div class="customItem">
          <img
            style="margin-right: 12%"
            class="customItemImgSecond"
            src="../assets/images/logo/fg-02_47.gif"
            alt=""
          />
        </div>
        <div class="customItem">
          <img
            style="width: 66%"
            class="customItemImgSecond"
            src="../assets/images/logo/fg-02_48.gif"
            alt=""
          />
        </div>
        <!-- 服装 -->
        <div class="customItem">
          <img
            class="customItemImg"
            src="../assets/images/logo/i_fuzhuang.png"
            alt=""
          />
        </div>
        <div class="customItem">
          <img
            class="customItemImgSecond"
            src="../assets/images/logo/fg-02_50.gif"
            alt=""
          />
        </div>
        <div class="customItem">
          <img
            class="customItemImgSecond"
            src="../assets/images/logo/fg-02_53.gif"
            alt=""
          />
        </div>
        <div class="customItem">
          <img
            style="margin-right: 6%"
            class="customItemImgSecond"
            src="../assets/images/logo/fg-02_54.gif"
            alt=""
          />
        </div>
        <div class="customItem">
          <img
            style="margin-right: 8%"
            class="customItemImgSecond"
            src="../assets/images/logo/fg-02_55.gif"
            alt=""
          />
        </div>
        <div class="customItem">
          <img
            style="width: 80%; margin-right: 6%"
            class="customItemImgSecond"
            src="../assets/images/logo/fg-02_56.jpg"
            alt=""
          />
        </div>
      </div>
    </div>

    <!-- 橙子 -->
    <div class="orangeBox">
      <img
        class="orangeImg wow animate__animated animate__fadeIn"
        src="../assets/images/ABUIABAEGAAg9_TjkQYo2Y-l7AUwgB44-AU.png"
        alt=""
      />
    </div>

    <!-- 信息 -->
    <div class="infoBox">
      <div class="infoBlock">
        <div class="infoName">
          <span>乌东面</span>
        </div>
        <div class="infoTip">
          <span>赞意GGN 合伙人</span>
        </div>
        <div class="infoTip">
          <span>业务负责人</span>
        </div>

        <div class="codeBox">
          <div class="infoItem">
            <div class="infoTip">微信：</div>
            <img class="infoCode" src="../assets/images/erweima1.gif" alt="" />
          </div>
          <div class="infoItem">
            <div class="infoTip">小红书：</div>
            <img class="infoCode" src="../assets/images/hong1.png" alt="" />
          </div>
        </div>

        <!-- <div class="infoItem">
          <div class="infoTip">电话：</div>
          <div class="infoTip">13810103993</div>
        </div> -->
        
        <div class="infoItem">
          <div class="infoTip">邮箱：</div>
          <div class="infoTipTxt">wudongwei@goodideamedia.com</div>
        </div>
      </div>

      <!-- <div class="infoBlock infoBlockCompany">
        <div class="infoName">
          <span>郭鹏天</span>
        </div>
        <div class="infoTip">
          <span>赞意GGN CHO</span>
        </div>
        <div class="infoTip">
          <span>集团人才负责人</span>
        </div>
        <div class="infoItem">
          <div class="infoTip">微信：</div>
          <img class="infoCode" src="../assets/images/erweima2.gif" alt="" />
        </div>
        <div class="infoItem">
          <div class="infoTip">电话：</div>
          <div class="infoTip">18601613637</div>
        </div>
        <div class="infoItem">
          <div class="infoTip">邮箱：</div>
          <div class="infoTipTxt">peggy@goodideamedia.com</div>
        </div>
      </div> -->

      <div class="infoBlock infoBlockCompany">
        <div class="wow animate__animated animate__headShake">
          <div class="infoTip">网站</div>
          <div class="infoTipTxt">www.goodideamedia.com</div>
          <div class="infoTipTxt" style="margin-top: 0.1rem">
            contact@goodideamedia.com
          </div>
        </div>
        <div class="infoItemR">
          <div class="infoTip">公司地址</div>
          <div class="infoTip16">
            赞意北京：北京市东城区东四十条94号亮点文创园A座701-702
          </div>
          <div class="infoTip16">
            赞意上海：上海市虹口区嘉兴路街道飞虹路118号瑞虹企业天地1号楼606
          </div>
        </div>
        <div class="companyCode">
          <img
            class="companyCodeImg wow animate__animated animate__flash"
            src="../assets/images/ABUIABACGAAgnfWSkgYokInUowcwggI4ggI.jpg"
            alt=""
          />
        </div>
      </div>
    </div>

    <!-- 备案 -->
    <div class="footerBox" style="position: relative;">
      <div class="beian">
        <span>© 2022 Goodidea 赞意　　京ICP备18002810号</span>
      </div>
      <!-- <div style="width: 40px;height: 40px;background: rgba(255, 255, 255, .1);position: absolute;right: 0;bottom: 0;cursor: pointer;" @click="goListFun"></div> -->
    </div>
  </div>
</template>
  
  <script>
import { WOW } from "wowjs";
import { debounce } from "../utils/util.js";
import naviHeader from "@/components/naviHeader.vue";
export default {
  name: "Index",
  data() {
    return {
      caseListObj: {
        left: [],
        center: [],
        right: [],
      },
      isScroll: false,
      videoLoad:true,
    };
  },
  components: {
    naviHeader,
  },

  mounted() {
    window.addEventListener("scroll", this.handleScroll, true); // 监听（绑定）滚轮滚动事件
    //页面渲染完，在执行
    this.$nextTick(() => {
      let wow = new WOW({
        live: false,
      });
      // console.log("wow:",wow)
      wow.init();
    });

    //获取屏幕尺寸
    // this.screenWidth = document.body.clientWidth;
    // window.onresize = debounce(() => {
    //   this.screenWidth = document.body.clientWidth;
    // }, 200);

    // this.screenWidth = this.$store.state.screenWidth;
    // console.log("this.screenWidth:",this.screenWidth)

    this.getCaseListFun();
  },

  watch: {
    // screenWidth: function (n, o) {
    //   console.log("nnn:",n,"oooo:",o)
    //   if (n <= 768) {
    //     // console.log("屏幕宽度小于768了");
    //     this.indexnaviType = "mobile";
    //   } else {
    //     // console.log("屏幕宽度没有小于768");
    //     this.indexnaviType = "pc"
    //   }
    // },
  },

  methods: {
    //获取案例信息
    getCaseListFun() {
      this.getDataInfo("post2", "/business/project/list", "").then((res) => {
        // console.log("获取案例信息", res.data);
        if (res.data.code == 200) {
          this.caseListObj = res.data.data;
        }
      });
    },

    videoPlayFun(e){
      console.log("视频加载")
    },
    videoPlayingFun(e){
      if(this.videoLoad){
        console.log("视频缓存")
        this.videoLoad = false
      }
    },

    goMyworksFun() {
      if (this.$store.state.screenWidth <= 768) {
        this.$router.push("/chengji");
      }

      console.log("goMyworksFun");
    },

    goListFun(){
       this.$router.push("/videolist");
    },

    handleScroll(e) {
      // console.log("滚动距离",e);
      // let scrollTop = e.target.scrollTop;
      // console.log("scrollTop:",scrollTop);

      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      // console.log("scrollTop:",scrollTop);
      if (scrollTop > 5) {
        this.isScroll = true;
      } else {
        this.isScroll = false;
      }
    },
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped>
@import "../assets/style/index.css";
@import "../assets/style/index_mobile.css";
</style>
  


// WEBPACK FOOTER //
// src/pages/index.vue